const COOKIE_CONSENT_BUTTON_FORM_PREFIX = 'cookie-form-'
const COOKIES_KEYS = ['audienceMeasurement', 'captcha']

class CookiesConsentController {

  constructor ($rootScope, $window, I18n, CookiesService) {
    'ngInject'
    this.COOKIES_KEYS = COOKIES_KEYS
    this.CookiesService = CookiesService
    this.$rootScope = $rootScope
    this.$window = $window
    this.I18n = I18n
  }

  save () {
    this.CookiesService.consent = COOKIES_KEYS.reduce((result, item) => {
      result[item] = document.getElementById(COOKIE_CONSENT_BUTTON_FORM_PREFIX + item).checked
      return result
    }, {})
    this.onUpdate()
  }

  acceptAll () {
    this.CookiesService.consent = COOKIES_KEYS.reduce((result, item) => {
      result[item] = true
      return result
    }, {})
    this.onUpdate()
  }

  rejectAll () {
    this.CookiesService.consent = COOKIES_KEYS.reduce((result, item) => {
      result[item] = false
      return result
    }, {})
    this.onUpdate()
  }

  onUpdate () {
    this.CookiesService.requestEdit = false
    this.open = false
    this.$rootScope.$broadcast('cookieConsentUpdated')
  }

  get consent () {
    let consent = this.CookiesService.consent
    if (consent === null || typeof consent !== 'object') {
      consent = {}
    }
    for (let key in consent) {
      if (COOKIES_KEYS.indexOf(key) === -1) {
        delete consent[key]
      }
    }
    for (let i = 0; i < COOKIES_KEYS.length; i++) {
      let cookieskey = COOKIES_KEYS[i]
      if (!consent.hasOwnProperty(cookieskey) || typeof consent[cookieskey] !== 'boolean') {
        consent[cookieskey] = false
      }
    }
    return consent
  }

  get shouldBeOpen () {
    return !this.consentUpToDate || this.CookiesService.requestEdit
  }

  get consentUpToDate () {
    let consent = this.CookiesService.consent
    // migration from the old way of managing consent
    // if a key is missing, the consent is ask again (old values are kept)
    if (consent !== null && typeof consent === 'object') {
      for (let i = 0; i < COOKIES_KEYS.length; i++) {
        if (!consent.hasOwnProperty(COOKIES_KEYS[i])) {
          return false
        }
      }
      return true
    }
    return false
  }
}

export default CookiesConsentController



// WEBPACK FOOTER //
// ./src/app/common/cookies-consent/cookies-consent.controller.js